const ErrorCodes = {
  access_denied: 'access_denied',
  auth_failed: 'auth_failed',
  invalid_token: 'invalid_token'
}

export default ErrorCodes
